import type { LocationRecord, LocationSchema } from '@libs/data-access/entities'
import { useEffect, useState } from 'react'

import { getBreakDurationFromPercentage } from '../utils'
import { canSetAutomaticBreaks } from '../utils/canSetAutomaticBreaks'

type Props = {
  location: LocationRecord | LocationSchema
  shiftTimeRange: [string, string]
  shiftId?: number
}

const useDefaultBreakValue = ({
  location,
  shiftTimeRange,
  shiftId
}: Props): number => {
  const [defaultBreakValue, setDefaultBreakValue] = useState(0)

  useEffect(() => {
    const automaticBreaksEnabled = canSetAutomaticBreaks(
      location,
      shiftTimeRange
    )
    const isHoursRangeInputValid = shiftTimeRange.find(time =>
      time.includes('_')
    )
    if (!shiftId && automaticBreaksEnabled && !isHoursRangeInputValid) {
      if (location?.default_break_duration_type === 'percentage') {
        const defaultBreak = getBreakDurationFromPercentage(
          shiftTimeRange,
          Number(location?.default_break_duration)
        )
        return setDefaultBreakValue(defaultBreak)
      }

      return setDefaultBreakValue(Number(location?.default_break_duration))
    }

    /**
     * If shift exists we should apply a defaultDuration = 0
     * Includes the case of real ones
     */
    return setDefaultBreakValue(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shiftTimeRange])

  return defaultBreakValue
}

export default useDefaultBreakValue
